import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import withAuthorization from "../../components/Authorization/withAuthorization";
import NoDataFound from "../Errors/NoDataFound";
import Loading from "../../components/Loading/Loading";
import { style } from "variables/Variables.jsx";
import { confirmAlert } from "react-confirm-alert";
import NotificationSystem from "react-notification-system";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  DeleteButton,
  SizePerPageDropDown,
} from "react-bootstrap-table";
import { Button } from "react-bootstrap";
import AddGroupModal from "./AddGroupModal";
import LocksButton from "./LocksButton";
import MembersButton from "./MembersButton";
import _ from "lodash";

import LocalizedStrings from "react-localization";
import { customLog } from "../../variables/Variables";

let localizationStrings = new LocalizedStrings({
  en: {
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
  },
  ja: {
    resultTitle1: "表示 ",
    resultTitle2: " へ ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
  },
  es: {
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
  },
});

const customTotal = (from, to, size) => (
  <span
    className="react-bootstrap-table-pagination-total"
    style={{ float: "right" }}
  >
    {localizationStrings.resultTitle1}
    {from}
    {localizationStrings.resultTitle2}
    {to}
    {localizationStrings.resultTitle3}
    {size}
    {localizationStrings.resultTitle4}
  </span>
);

const customConfirmDialog = (next, dropRowKeys) => {
  //   // this.setState({show : true});
  confirmAlert({
    title: "Confirm delete group",
    message: "Are you sure? *Once deleted cannot be reverted.*",
    buttons: [
      {
        label: "Confirm",
        onClick: () => next(),
      },
      {
        label: "Cancel",
        onClick: () => {
          return false;
        },
      },
    ],
  });
};

const selectRowProp = {
  bgColor: "#eeeeee",
  mode: "checkbox",
};

class GroupManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupListArray: "",
      _notificationSystem: null,
      show: false,
    };

    //Firebase Stuff
    this.snapshotToArray = this.snapshotToArray.bind(this);

    //Locks And Members Buttons stuff
    this.renderMembersButton = this.renderMembersButton.bind(this);
    this.renderLocksButton = this.renderLocksButton.bind(this);

    //Database Stuff
    this.onToggleDropDown = this.onToggleDropDown.bind(this);
    this.renderSizePerPageDropDown = this.renderSizePerPageDropDown.bind(this);
    this.createCustomDeleteButton = this.createCustomDeleteButton.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.saveNameChange = this.saveNameChange.bind(this);
    this.showNotification = this.showNotification.bind(this);
    // this.afterInsertRow = this.afterInsertRow.bind(this);
    // this.renderAddGroupModal = this.renderAddGroupModal.bind(this);
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    // console.log(auth.currentUser.uid)
    fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid + "/userGroups")
      // .child(auth.currentUser.uid) // get uid from auth person object
      // .child("userGroups")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          //   console.log(snapshot.val().userGroups)
          var tempArray = [];
          tempArray = this.snapshotToArray(snapshot);
          // console.log(tempArray)
          this.setState({
            groupListArray: tempArray,
          });
        }
      });
  }

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  renderMembersButton(col, row) {
    // console.log(col)
    // var tempArray = [];
    // console.log(tempArray)
    return <MembersButton members={col}></MembersButton>;
  }

  renderLocksButton(col, row) {
    customLog(col);
    return <LocksButton groupUid={col}></LocksButton>;
  }

  onToggleDropDown = (toggleDropDown) => {
    // do your stuff here
    // console.log(toggleDropDown)
    // console.log('toggle dropdown');
    toggleDropDown();
  };

  renderSizePerPageDropDown = (props) => {
    return (
      <SizePerPageDropDown
        // className='my-size-per-page'
        // btnContextual='btn-warning'
        variation="dropup"
        onClick={() => this.onToggleDropDown(props.toggleDropDown)}
        {...props}
      />
    );
  };

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="searchBar"
        // id="retractSearch"
        placeholder="Search"
      />
    );
  };

  createCustomDeleteButton(onClick) {
    return (
      <Button bsSize="large" id="recipientDeleteBtn" onClick={onClick}>
        <i className="far fa-trash-alt" /> Delete Group
      </Button>
    );
  }

  createCustomInsertButton = (onClick) => {
    return (
      // <Button bsSize="large" id="addGroupBtn" onClick={this.renderAddGroupModal}>
      //   <i className="fa fa-plus" /> Add Group
      // </Button>
      <AddGroupModal />
    );
  };

  saveNameChange(row, col, newValue) {
    customLog(row);
    customLog(newValue);
    if (newValue !== "") {
      fire
        .database()
        .ref("groupAccounts/" + auth.currentUser.uid + "/userGroups")
        .child(row.key)
        .update({ groupName: newValue });
    }
  }

  onAfterDeleteRow(rowKeys) {
    customLog(rowKeys);
    for (let i = 0; i < rowKeys.length; i++) {
      fire
        .database()
        .ref("groupAccounts/" + auth.currentUser.uid + "/userGroups/")
        .child(rowKeys[i])
        .remove();
    }
    this.showNotification("Group successfully deleted !", "success", "tc", 3);
  }

  // afterInsertRow(row) {
  //   console.log(row)F
  // }

  //!TODO: ADD CELL / NAME EDIT STUFF HERE

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    //! FOR DATA
    const groupData = _.map(this.state.groupListArray, (groupData) => {
      // customLog(atData);
      //! Add group id to member to pass as props
      var membersWithKey = [];
      membersWithKey.groupId = groupData.key;
      membersWithKey.members = groupData.groupMembers;
      return {
        key: groupData.key,
        groupName: groupData.groupName,
        members: membersWithKey,
      };
    });

    const cellEditProp = {
      mode: "dbclick",
      blurToSave: true,
      //TODO: Edit name
      afterSaveCell: this.saveNameChange,
    };

    const options = {
      sizePerPageDropDown: this.renderSizePerPageDropDown,
      afterDeleteRow: this.onAfterDeleteRow,
      // afterInsertRow: this.afterInsertRow,
      handleConfirmDeleteRow: customConfirmDialog,
      // deleteBtn: this.createCustomDeleteButton,
      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: this.state.groupListArray.length,
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 10, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 10, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      // paginationShowsTotal: customTotal,
      paginationShowsTotal: customTotal,
      // noDataText: this.loadingData,
      // Accept bool or function
      // default is bottom, top and both is all available
      // hideSizePerPage: true > You can hide the dropdown for sizePerPage
      // alwaysShowAllBtns: true // Always show next and previous button
      // withFirstAndLast: false > Hide the going to First and Last page button// A hook for after droping rows.
      searchField: this.createCustomSearchField,
      deleteBtn: this.createCustomDeleteButton,
      insertBtn: this.createCustomInsertButton,
      // afterInsertRow: onAfterInsertRow, //A hook for after adding rows
    };

    return (
      <div className="header" style={{ maxWidth: "95%", margin: "auto" }}>
        <NotificationSystem ref="notificationSystem" style={style} />

        <h2>Group Management</h2>
        <h4>Create and edit your group here</h4>
        <h6 className="instructionStyle">Double Click name to edit</h6>

        <BootstrapTable
          id="table"
          pagination={true}
          search
          bordered={false}
          data={groupData}
          selectRow={selectRowProp}
          deleteRow
          options={options}
          cellEdit={cellEditProp}
          insertRow
        >
          <TableHeaderColumn
            dataSort
            dataField="key"
            isKey={true}
            hidden
          ></TableHeaderColumn>
          <TableHeaderColumn dataSort dataField="groupName" editable={true}>
            Group Name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="key"
            dataFormat={this.renderLocksButton}
            editable={false}
          >
            Manage Locks
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="members"
            dataFormat={this.renderMembersButton}
            editable={false}
          >
            Manage Members
          </TableHeaderColumn>
        </BootstrapTable>
        {/* <Add dataCallBack={this.updateTable} /> */}
      </div>
    );
  }
}

export default GroupManagement;
